import { useState } from "react";
import { KeyRound, Loader2, RefreshCw, Copy } from "lucide-react";
import api, { formatDetail } from "@/lib/api";

const LABEL = { payin: "PayIn callbacks", payout: "Payout webhooks" };

export const SecretCard = ({ kind, info, canEdit, onChanged }) => {
    const [busy, setBusy] = useState(false);
    const [fresh, setFresh] = useState("");
    const [err, setErr] = useState("");

    const rotate = async () => {
        const msg = info?.has_secret
            ? "Rotate this secret? Your server must switch to the new secret immediately — webhooks signed with the old one will fail verification."
            : "Generate a signing secret?";
        if (!window.confirm(msg)) return;
        setBusy(true); setErr("");
        try {
            const r = await api.post(`/partner/webhook-signing/${kind}/rotate`);
            setFresh(r.data.secret);
            onChanged?.();
        } catch (e) { setErr(formatDetail(e?.response?.data?.detail) || e.message); }
        finally { setBusy(false); }
    };

    return (
        <div className="border border-slate-200 rounded-lg p-4 bg-white" data-testid={`wh-sign-secret-${kind}`}>
            <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 font-semibold text-sm"><KeyRound className="w-4 h-4 text-indigo-600" /> {LABEL[kind]}</div>
                {canEdit && (
                    <button type="button" onClick={rotate} disabled={busy} data-testid={`wh-sign-rotate-${kind}`}
                            className="btn-secondary px-2.5 py-1.5 rounded-md text-xs flex items-center gap-1.5">
                        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
                        {info?.has_secret ? "Rotate" : "Generate"}
                    </button>
                )}
            </div>
            <dl className="mt-3 grid grid-cols-[90px_1fr] gap-y-1.5 text-xs">
                <dt className="text-slate-500">Endpoint</dt>
                <dd className="font-mono break-all text-slate-800" data-testid={`wh-sign-url-${kind}`}>{info?.url || <span className="text-slate-400">not configured</span>}</dd>
                <dt className="text-slate-500">Secret</dt>
                <dd className="font-mono text-slate-800" data-testid={`wh-sign-hint-${kind}`}>{info?.secret_hint || <span className="text-slate-400">none yet</span>}</dd>
            </dl>
            {fresh && (
                <div className="mt-3 bg-amber-50 border border-amber-200 rounded-md p-2.5" data-testid={`wh-sign-fresh-${kind}`}>
                    <div className="text-[11px] font-semibold text-amber-900 mb-1">New secret — copy it now, it won't be shown again</div>
                    <div className="flex items-center gap-2">
                        <code className="font-mono text-[11px] break-all text-amber-950 flex-1">{fresh}</code>
                        <button type="button" onClick={() => navigator.clipboard?.writeText(fresh)} data-testid={`wh-sign-copy-secret-${kind}`}
                                className="text-amber-800 hover:text-amber-950"><Copy className="w-3.5 h-3.5" /></button>
                    </div>
                </div>
            )}
            {err && <div className="mt-2 text-xs text-rose-600" data-testid={`wh-sign-err-${kind}`}>{err}</div>}
        </div>
    );
};
